import { render, staticRenderFns } from "./VersionPush.vue?vue&type=template&id=6ebdd0c0&scoped=true"
import script from "./VersionPush.vue?vue&type=script&lang=js"
export * from "./VersionPush.vue?vue&type=script&lang=js"
import style0 from "./VersionPush.vue?vue&type=style&index=0&id=6ebdd0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebdd0c0",
  null
  
)

export default component.exports